import React from 'react';
import about from '../../content/About';
import partner from '../../content/Partner';

import styles from './AboutMission.module.css'

const AboutMission = () => {
    return (
        <div className={styles.content}>
            <div>
                <h1 className={styles.title}>Qui sommes nous <span className={styles.highlight}>?</span></h1>
                <p className={styles.text}>{about}</p>
            </div>
            <div>
                <h1 className={styles.title}>Devenir partenaire avec DealyGo <span className={styles.highlight}>?</span></h1>
                <p className={styles.text}>{partner}</p>
                <a className={styles.link} href='/Asset/Dealygo_Flyer.pdf' download='Dealygo_Flyer.pdf'>Télécharger notre flyer</a>
            </div>
        </div>
    );
};

export default AboutMission;